(function () {
	const TITLE_SELECTOR = ".product-about__accordion-title";
	const PANEL_SELECTOR = ".product-about__accordion-content, .contact-faqs__answer";
	const EVENT_NAMESPACE = ".productAboutToggle";

	const initProductAccordion = () => {
		const $titles = $(TITLE_SELECTOR);
		if (!$titles.length) return;

		$titles.off(`click${EVENT_NAMESPACE} keydown${EVENT_NAMESPACE}`).on(`click${EVENT_NAMESPACE} keydown${EVENT_NAMESPACE}`, function (event) {
			if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") {
				return;
			}

			const $this = $(this);
			const isActive = $this.hasClass("active");

			$(TITLE_SELECTOR).removeClass("active");
			$(PANEL_SELECTOR).stop().slideUp(200);

			if (!isActive) {
				$this.addClass("active");
				$this.siblings(PANEL_SELECTOR).stop().slideDown(200);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
